export function decodeHtmlEntities(s = "") {
    return s
      .replace(/&quot;/g, '"')
      .replace(/&#x27;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }
  export function safeParseCmsAttr(el) {
    let raw = el.getAttribute("data-cms-content") || "{}";
    try {
      // strip out anything that could break JSON or start a tag/script
      // kill any <script> or angle brackets
      raw = decodeHtmlEntities(raw);
      raw = raw.replace(/</g, "\\u003c").replace(/>/g, "\\u003e");
   
      // now try to parse
      return JSON.parse(raw);
    } catch (e) {
      console.error("Invalid CMS content", e);
      return {};
    }
  }